export default __webpack_public_path__ + "static/DSC_0089-5f22135ade6ddb9151ff17c39cb919d8.jpg";